module.exports = __webpack_public_path__ + "static/img/ppixarone.c15435cf.png";